import Common from '../wp-controlers/common-panel/geralAttributes';

export default {
  containerized: {
    type: 'boolean',
    default: false,
  },
  sideImage: {
    type: 'object',
    default: {
      id: '',
      src: '',
      alt: '',
    },
  },
  withFigcaption: {
    type: 'boolean',
    default: false,
  },
  figcaption: {
    type: 'string',
    default: '',
  },
  contentPosition: {
    type: 'string',
    default: 'right',
  },
  imagePosition: {
    type: 'string',
    default: 'imageTop',
  },
  variant: {
    type: 'string',
    default: 'vertical',
  },
  background: {
    type: 'string',
    default: 'bg-grey-light',
  },
  titleFull: {
    type: 'boolean',
    default: false,
  },
  titleDownImage: {
    type: 'boolean',
    default: false,
  },
  padding: {
    type: 'string',
    default: 'none',
  },
  ...Common,
};
